<template>
  <document-container
      v-if="template && response"
      :footer="[]"
      :header="header"
      :logo="logo"
      documentType="approval"
      orientation="landscape"
  >
    <template
        v-for="(step, stepKey) in response.steps"
    >

      <!--      <div-->
      <!--          slot="raw-body"-->
      <!--          class="page-block"-->
      <!--          v-if="step.layoutType === 'GROUP'"-->
      <!--      >-->
      <!--        <h2 v-if="step.title">{{ step.title }}-->
      <!--          <footnotes v-if="step.footnotes" :all-footnotes="footnotes" :local-footnotes="step.footnotes"></footnotes>-->
      <!--        </h2>-->

      <!--        <component-->
      <!--            :is="'APPROVAL_' + field.fieldType"-->
      <!--            v-for="(field, fieldKey) in step.fields"-->
      <!--            v-if="!field.conditionalOn || (step.fields.find( el => el.key === field.conditionalOn).props.defaultValue)"-->
      <!--            :key="stepKey + '-' + fieldKey"-->
      <!--            :data="field"-->
      <!--            :footnotes="footnotes"-->
      <!--        ></component>-->
      <!--      </div>-->

      <!--      <template-->
      <!--          v-if="step.layoutType === 'LIST'"-->
      <!--      >-->
      <div
          slot="raw-body"
          class="page-block fake-block"
          v-if="step.title"
      >
        <h2>{{ step.title }}
          <footnotes v-if="step.footnotes" :all-footnotes="footnotes" :local-footnotes="step.footnotes"></footnotes>
        </h2>
      </div>

      <component
          :is="'APPROVAL_' + field.fieldType"
          v-for="(field, fieldKey) in step.fields"
          v-if="!field.conditionalOn || (step.fields.find( el => el.key === field.conditionalOn).props.defaultValue)"
          :key="stepKey + '-' + fieldKey"
          :data="field"
          slot="raw-body"
          class="page-block fake-block"
          :footnotes="footnotes"
      ></component>

    </template>

    <div
        slot="raw-body"
        class="page-block"
    >
      <div>
        <strong>Erfasser:</strong> {{ email }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<strong>Datum:</strong> {{ moment().format('DD. MMMM YYYY') }}
      </div>
    </div>

    <div
        slot="raw-body"
        class="page-block"
    >
      <hr>
      <div v-for="(footnote, index) in footnotes">
        <span style="vertical-align: super;font-size: 8px; font-weight: lighter">{{ index + 1 }}</span>
        {{ footnote }}
      </div>
    </div>
  </document-container>
</template>

<script>
import DocumentContainer
  from '../document/DocumentContainer'
import BlockMixin
  from '../block/BlockMixin'
import TemplateManager
  from "../../service/TemplateManager"
import TableShortlistProducts
  from "../table/TableShortlistProducts"
import APPROVAL_CHECKBOX
  from "./field-types/CHECKBOX.vue"
import APPROVAL_TEXT
  from "./field-types/TEXT.vue"
import APPROVAL_TEXTAREA
  from "./field-types/TEXTAREA.vue"
import APPROVAL_INPUT
  from "./field-types/INPUT.vue"
import APPROVAL_TABLE
  from "./field-types/TABLE.vue"
import APPROVAL_NESTED_GROUP
  from "./field-types/NESTED_GROUP.vue"
import Footnotes
  from "./field-types/Footnotes.vue"
import ProductService
  from "../../service/ProductService"
import TokenService
  from "../../service/TokenService"

export default {
  name: 'approval',
  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/shortlist.css',
        },
      ]
    },
  },

  components: {
    DocumentContainer,
    TableShortlistProducts,
    APPROVAL_CHECKBOX,
    APPROVAL_TEXT,
    APPROVAL_TEXTAREA,
    APPROVAL_INPUT,
    APPROVAL_TABLE,
    APPROVAL_NESTED_GROUP,
    Footnotes,
  },

  data() {
    return {
      template: null,
      response: null,
      email: null,
      footnotes: [],
      currentFootnote: 1,
    }
  },

  mixins: [BlockMixin],

  props: {
    environment: {
      type: String,
      default: 'sparkasse',
    },
    id: {
      type: String,
      required: true,
    },
  },

  computed: {
    logo() {
      return ['config', this.environment, 'images', 'approval.png'].join('/')
    },
    header() {
      return [{
        type: 'Pagetitle',
        title: this.response.title,
        position: 'header',
        sort: 1,
        shared: true,
      }]
    },
  },

  methods: {
    getTemplateManager(template) {
      return new TemplateManager(template)
    },
    getFormattedTable(elements) {
      let table = []
      elements.map((el, i) => {
        if (i % 2 === 0) {
          table.unshift([])
        }
        table[0].push(el)
      })
      return table
    },
  },

  async created() {
    let token

    if (this.$route.query.token) {
      token = this.$route.query.token
    } else {
      token = await TokenService.checkToken()
    }

    let res = await ProductService.getApproval(this.id, token)
    this.response = res.data.form

    // recursive check for any kind of footnotes
    let getFieldFootnotes = (fields) => {

      for (let field of fields) {
        if (field.conditionalOn && !(fields.find(el => el.key === field.conditionalOn).props.defaultValue)) {
          return
        }

        if (field.footnotes) {
          this.footnotes.push(...field.footnotes)
        }

        if (field.props && field.props.footnotes) {
          this.footnotes.push(...field.props.footnotes)
        }

        if (field.fields) {
          getFieldFootnotes(field.fields)
        }

        if (field.rows) {
          getFieldFootnotes(field.rows)
        }
      }
    }

    // start footnote check
    getFieldFootnotes(this.response.steps)

    // filter out duplicates, preserving original order
    this.footnotes = this.footnotes.reduce(function (a, b) {
      if (a.indexOf(b) < 0) a.push(b)
      return a
    }, [])

    this.email = res.data.exporterMail
    this.template = this.getTemplateManager()
  },
}
</script>

<style lang="scss">
$primary: red;
.approval {
  .logo {
    top: 20mm !important;
  }

  .header {
    margin-top: 0 !important;
  }

  .page-title h1 {
    color: red;
    height: 35px !important;
    max-height: unset !important;
    max-width: 333px !important;
  }

  //.page-block {
  //  padding: 20px !important;
  //  border: 1px solid #eee;
  //  margin: 15px 0;
  //}

  .page-block {
    //padding-top: 5px !important;
    //padding-bottom: 5px !important;
    padding: 4px 0 !important;

    &:first-child {
      h2 {
        margin-top: 0
      }
    }
  }


  &.content h2 {
    margin-top: 7px;
    margin-bottom: 7px;

    font-size: 1.3rem;
    font-weight: 300;
    text-transform: uppercase;
    color: red;
  }

  .textarea, .input {
    min-width: 200px;
    font-size: 1rem;
    padding: 5px;
  }

  .textarea {
    min-height: 0;
  }

  .table .checkbox {
    margin-top: 0 !important;
  }

  .checkbox {
    //margin-bottom: 20px;
    margin-right: 10px;
    display: block;

    > a {
      margin-left: 17px;
      color: red;
    }

    > .caption {
      margin-left: 17px;
    }

    input {
      vertical-align: bottom;
    }

    label {
      margin-left: 5px;
    }
  }

  .toggle-group {
    td {
      border: 1px solid #eee !important;
    }

    .selected {
      background-color: red;
      color: #fff
    }
  }

  td {
    border-bottom: 1px solid #eee;
  }

  .table {
    tr:first-child {
      font-weight: bold
    }

  }

  .text-input {
    margin-top: -10px;
  }

  .text {

    .text-table {
      margin-top: -10px;
    }

    &.SUCCESS {
      background-color: #dff0d8;
      padding: 10px;
      color: #3c763d;
      margin-bottom: 10px;
      margin-top: 10px;

    }

  }

  .text-table {

    border-bottom: 1px solid #dbdbdb;

  }

  .nested-group {
    //margin-bottom: 15px
  }

}
</style>



// WEBPACK FOOTER //
// Approval.vue?73fd30c4